<widget-section
  [displayTitle]="displayTitle"
  [title]="title"
  [widgets]="widgets"
>

</widget-section>
